import { useQuery } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';

import { useSeasonalTheme } from '../seasonal-theme-context';

export const summerGivenCountQueryKey = (enableDate?: string | null) => ['summer-given-count', enableDate];

export const useSummerGivenCount = () => {
	const { isSeasonalThemeEnabled, enableDate } = useSeasonalTheme();
	const http = useHttpClient('v2');

	return useQuery({
		queryKey: summerGivenCountQueryKey(enableDate),
		enabled: isSeasonalThemeEnabled && !!enableDate,
		queryFn: async () => {
			const res = await http.get<{ result: { given_count: number } }>('profile/recognition/activity_count', {
				params: { start_date: enableDate },
			});
			return res.data?.result?.given_count ?? 0;
		},
		staleTime: 5 * 60 * 1000, // Cache for 5 minutes
	});
};
